import { useEffect, useState } from "react";

const useDashboard = (url) => {
  const [totalProduct, setTotalProduct] = useState(null);
  const [totalSales, setTotalSales] = useState(null);
  const [totalUsers, setTotalUsers] = useState(null);
  const [totalNewUsers, setTotalNewUsers] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [analyticsData, setAnalyticsData] = useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/products/total-products`
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();

      setTotalProduct(result.total);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  const fetchTotalSales = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/orders/total-sales`
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();

      setTotalSales(result.total);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  const fetchTotalUsers = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/users/total-users`
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();

      setTotalNewUsers(result.totalNew);
      setTotalUsers(result.total);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/analytics/data`
      );
      const data = await res.json();

      setAnalyticsData(data.data);
    };

    fetchData();
  }, []);

  useEffect(() => {
    fetchData();
    fetchTotalSales();
    fetchTotalUsers();
  }, [url]);

  return {
    totalProduct,
    totalSales,
    loading,
    error,
    totalUsers,
    totalNewUsers,
    analyticsData,
  };
};

export default useDashboard;
